import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="not-found section-wrap">
      <span aria-hidden="true">404</span>
      <p className="kicker">Wrong corridor</p>
      <h1>This page missed the roll call.</h1>
      <Link className="button button--ink" to="/"><ArrowLeft aria-hidden="true" /> Back home</Link>
    </section>
  );
}
